import { Button } from "@Components/CustomButton/Button"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { TouchableOpacity, View } from "react-native"
export const EvaluationCardItem = (props) => {
    const { badge, title } = props

    return (
        <TouchableOpacity
            onPress={() => props.onPress()}
            activeOpacity={0.7}
            style={{
                padding: 15,
                backgroundColor: baseColors.orange.light,
                marginVertical: 5,
                marginHorizontal: 2,
                borderRadius: 10,
                elevation: 5
            }}
        >
            <OpenSansText fontWeight="bold" fontSize={14}>
                {title}
            </OpenSansText>

            <View style={{ alignSelf: "flex-start" }}>
                <Button
                    borderColor={baseColors.green.primary}
                    borderWidth={1}
                    roundness={30}
                    mode={"outlined"}
                    width="100%"
                    text={badge}
                    labelColor={baseColors.green.primary}
                />
            </View>
        </TouchableOpacity>
    )
}
